module.exports = "https://cdn.dashboard.gifty.nl/3273/images/download.svg?0cacc59f7766c7d54287302edc44388c";